// extracted by mini-css-extract-plugin
export var leftAlign = "_1j-2";
export var popper = "_1j-0";
export var subtitle = "_1j-1";